module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-299.d9c0787.woff2";